import React, {Fragment} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {Alert, Card, Col, Row} from "antd";
import {GUTTER_MD, PADDING_SM} from "../../../../../../styles/constants";

const mapStateToProps = ({
                             scenes: {mappingHandler: {mappingSet: {wizard, index}}}
                         }) => ({
    validateStatus: wizard.validateFormatStatus,
});

const MappingSetValidateFormat = ({t, validateStatus}) => {
    if (!validateStatus) return null
    if (validateStatus.status === "Error") {
        return <Alert type="warning"
                      message={<ul>{validateStatus.messages.map(item => <li>{item}</li>)}</ul>}
                      showIcon/>
    }
    if (validateStatus.ReturnCode === 0) {
        return (
            <Fragment>
                <Alert type="success"
                       message={t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.noErrors")}
                       showIcon/>
                <Card>
                    <Row type="flex" style={{flexDirection: "column"}}
                         gutter={PADDING_SM}>
                        <Col>
                        <span style={{fontWeight: "bold"}}>
                            {t('scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.structureInfo')}
                        </span>
                        </Col>
                        <Col>
                            <span style={{fontWeight: "bold"}}>Name: &nbsp;</span>
                            <span>{validateStatus.StructureInfo.Name}</span>
                        </Col>
                        <Col>
                            <span style={{fontWeight: "bold"}}>Agency: &nbsp;</span>
                            <span>{validateStatus.StructureInfo.Agency}</span>
                        </Col>
                        <Col>
                            <span style={{fontWeight: "bold"}}>Version: &nbsp;</span>
                            <span>{validateStatus.StructureInfo.Version}</span>
                        </Col>
                    </Row>
                </Card>

            </Fragment>
        )
    }

    return (
        <Fragment>
            <Alert
                style={{marginBottom: GUTTER_MD}}
                message={validateStatus.errorFound === 1 ? t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.singleErrorFound")
                    : t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.errorsFound", {number: validateStatus.errorFound})}
                type="warning"
                showIcon
            />
            <Card bodyStyle={{overflow: "auto", maxHeight: "75vh"}}>
                <ul>{(validateStatus.Error || []).map((msg, idx) => <li key={idx}>{msg.Dimension ? `${msg.Dimension} - ` : ""} {msg.Description} {msg.Detail ? `(${msg.Detail})` : ""}</li>)}</ul>
            </Card>
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps),
)(MappingSetValidateFormat);